/* eslint-disable max-len */
import React, { Fragment, useRef, useState } from 'react';
import moment from 'moment';
import { useOnClickOutside } from '../../../CommonMethods/OutsideClick';
import { getNoticeTypeLabel } from '../Classroom/noticeTypeUtils';

export default function BroadcastsTable({
    data,
    canEdit,
    canDelete,
    setConfirmationState,
    navigate,
    emptyScreenMessage,
    typeOptions,
    currentQuery = '',
    broadcastContext = {},
}) {
    const [selectedIndex, setSelectedIndex] = useState(null);
    const selectedRef = useRef(null);
    useOnClickOutside(selectedRef, () => setSelectedIndex(null));
    const querySuffix = currentQuery ? `?${currentQuery}` : '';

    return (
        <div className="-mx-1">
            <div className={`flex overflow-auto ${data.length < 10 ? 'pb-[100px]' : 'pb-[6px]'} scroll-bar px-1`} id = "search-result">
                <table aria-label="Broadcasts Table" className="w-full" id="admin-table">
                    <thead>
                        <tr>
                            <th className="w-[14%]"><span>Date</span></th>
                            <th className="w-[12%]"><span>Type</span></th>
                            <th className="w-[28%]"><span>Title</span></th>
                            <th className="w-[18%]"><span>Added by</span></th>
                            <th className="w-[10%]"><span className="flex items-center justify-center">Actions</span></th>
                        </tr>
                        <tr aria-colspan="6" className="h-1"></tr>
                    </thead>
                    <tbody>
                        {data.map((item, index) => {
                            const titleText = item.title || '-';
                            const truncatedTitle = titleText.length > 50
                                ? `${titleText.substring(0, 50)}...`
                                : titleText;
                            const viewPath = `/noticeboard/broadcasts/view/${item._id}${querySuffix}`;
                            const editPath = `/noticeboard/broadcasts/edit/${item._id}${querySuffix}`;

                            return (
                                <Fragment key={item._id}>
                                    <tr className="tbl-row cursor-pointer" onClick={() => navigate(viewPath, { state: { broadcastContext } })}>
                                        <td>{moment(item.date).format('MMM DD, YYYY')}</td>
                                        <td>{getNoticeTypeLabel(item.type, typeOptions, item.type || '-')}</td>
                                        <td title={titleText}>{truncatedTitle}</td>
                                        <td>{item.created_by_name || '-'}</td>
                                        <td className="prevent-click" onClick={(e) => e.stopPropagation()}>
                                            <div className="relative flex items-center justify-center prevent-click">
                                                <button
                                                    type="button"
                                                    className="list-more-btn prevent-click"
                                                    onClick={() => setSelectedIndex(selectedIndex === index ? null : index)}
                                                >
                                                    <img loading="lazy" decoding="async" src="/images/listAction.svg" alt="actions" className="prevent-click" />
                                                </button>
                                                {selectedIndex === index && (
                                                    <ul
                                                        ref={selectedRef}
                                                        className={`${(index + 1 === 10 || index + 2 === 10) ? 'top3' : ''} list-more-optns-div [&[data-te-dropdown-show]]:block prevent-click`}
                                                    >
                                                        <li>
                                                            <button
                                                                type="button"
                                                                className="list-more-optns prevent-click"
                                                                onClick={() => {
                                                                    navigate(viewPath, { state: { broadcastContext } });
                                                                    setSelectedIndex(null);
                                                                }}
                                                            >
                                                                View Details
                                                            </button>
                                                        </li>
                                                        {canEdit(item) && (
                                                            <li>
                                                                <button
                                                                    type="button"
                                                                    className="list-more-optns prevent-click"
                                                                    onClick={() => {
                                                                        navigate(editPath, { state: { broadcastContext } });
                                                                        setSelectedIndex(null);
                                                                    }}
                                                                >
                                                                    Edit
                                                                </button>
                                                            </li>
                                                        )}
                                                        {canDelete(item) && (
                                                            <li>
                                                                <button
                                                                    type="button"
                                                                    className="list-more-optns prevent-click"
                                                                    onClick={() => {
                                                                        setConfirmationState({ item });
                                                                        setSelectedIndex(null);
                                                                    }}
                                                                >
                                                                    Delete
                                                                </button>
                                                            </li>
                                                        )}
                                                    </ul>
                                                )}
                                            </div>
                                        </td>
                                    </tr>
                                </Fragment>
                            );
                        })}
                    </tbody>
                    {data.length === 0 && (
                        <tbody>
                            <tr>
                                <td style={{ lineHeight: '100px' }} colSpan="6" className="no-records-message" id="no-matching-result">
                                    {emptyScreenMessage || 'No matching records found.'}
                                </td>
                            </tr>
                        </tbody>
                    )}
                </table>
            </div>
        </div>
    );
}
